module.exports = __webpack_public_path__ + "img/thumbnail_WesternLowlandGorilla_m_normal.cc48d7d0.png";